module.exports = __webpack_public_path__ + "static/media/abe-o.f380d0ac.png";